export const FETCH_BOARDS = 'FETCH_BOARDS';
export const ADD_NEW_BOARD = 'ADD_NEW_BOARD';
export const ADD_NEW_CARD = 'ADD_NEW_CARD';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_MEMBERS = 'FETCH_MEMBERS';
export const UPDATE_BOARDS = 'UPDATE_BOARDS';
